var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlotly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #8c99cd;\n      }\n\n      .cls-3 {\n        fill: #282d33;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 44.87,
    y1: 40.43,
    x2: 102.87,
    y2: 40.43,
    gradientTransform: "translate(2 -3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe4ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.16,
    cy: 45.71,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.73,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.16,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 67.59,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 51.01,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 51.01,
    cy: 45.71,
    r: 4.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.16,
    cy: 45.71,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.73,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.16,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.59,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.01,
    cy: 29.14,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.01,
    cy: 45.71,
    r: 4.14
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 157.34,
    y: 32.94,
    width: 5.78,
    height: 34.68,
    rx: 2.89,
    ry: 2.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 218.03,
    y: 32.94,
    width: 5.78,
    height: 34.68,
    rx: 2.89,
    ry: 2.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.99,38.72c-2.2,0-4.25.66-6,1.79-.43-1.05-1.47-1.79-2.67-1.79-1.6,0-2.89,1.29-2.89,2.89v28.9c0,1.6,1.29,2.89,2.89,2.89s2.89-1.29,2.89-2.89v-4.55c1.7,1.05,3.67,1.66,5.78,1.66,6.38,0,11.56-5.55,11.56-12.39v-4.13c0-6.84-5.18-12.39-11.56-12.39ZM145.78,55.54c0,3.48-2.59,6.31-5.78,6.31s-5.78-2.82-5.78-6.31v-4.73c0-3.48,2.59-6.31,5.78-6.31s5.78,2.82,5.78,6.31v4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.46,38.72h0c-6.38,0-11.56,5.55-11.56,12.39v4.13c0,6.84,5.18,12.39,11.56,12.39h0c6.38,0,11.56-5.55,11.56-12.39v-4.13c0-6.84-5.18-12.39-11.56-12.39ZM186.24,55.54c0,3.48-2.59,6.31-5.78,6.31s-5.78-2.82-5.78-6.31v-4.73c0-3.48,2.59-6.31,5.78-6.31s5.78,2.82,5.78,6.31v4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.36,61.84c-3.19,0-5.78-2.59-5.78-5.78v-11.56h5.78c1.6,0,2.89-1.29,2.89-2.89s-1.29-2.89-2.89-2.89h-5.78v-2.89c0-1.6-1.29-2.89-2.89-2.89s-2.89,1.29-2.89,2.89v20.23c0,6.37,5.19,11.56,11.56,11.56,1.6,0,2.89-1.29,2.89-2.89s-1.29-2.89-2.89-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.95,38.96c-1.47-.63-3.17.05-3.8,1.52l-5.99,13.98-5.99-13.98c-.63-1.47-2.33-2.15-3.8-1.52-1.47.63-2.15,2.33-1.52,3.8l8.16,19.04-.97,2.26c-.88,2.11-2.92,3.51-5.21,3.56-1.6.04-2.86,1.36-2.82,2.96.04,1.57,1.32,2.82,2.89,2.82.02,0,.05,0,.07,0,4.57-.11,8.65-2.9,10.4-7.09l10.1-23.55c.63-1.47-.05-3.17-1.52-3.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.01,58.14c-2.29,0-4.14,1.85-4.14,4.14v16.57c0,2.29,1.85,4.14,4.14,4.14s4.14-1.85,4.14-4.14v-16.57c0-2.29-1.85-4.14-4.14-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.16,58.14c-2.29,0-4.14,1.85-4.14,4.14v16.57c0,2.29,1.85,4.14,4.14,4.14s4.14-1.85,4.14-4.14v-16.57c0-2.29-1.85-4.14-4.14-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.59,41.57c-2.29,0-4.14,1.85-4.14,4.14v33.14c0,2.29,1.85,4.14,4.14,4.14s4.14-1.85,4.14-4.14v-33.14c0-2.29-1.85-4.14-4.14-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.73,41.57c-2.29,0-4.14,1.85-4.14,4.14v33.14c0,2.29,1.85,4.14,4.14,4.14s4.14-1.85,4.14-4.14v-33.14c0-2.29-1.85-4.14-4.14-4.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotly);
export default __webpack_public_path__ + "static/media/plotly.bc66ec6c7642e34a9462b40903e5cecd.svg";
export { ForwardRef as ReactComponent };